import React from 'react';
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import {Add, Delete, Visibility} from "@material-ui/icons";

const DaScreenHeader: React.FC = () => {

  return (
    <>
      <div className="header pt-md-7"
      style={{
        backgroundColor: '#2D315C',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: "url(/background-header-infinity.jpg)"
      }}>
        <span className="mask bg-gradient-default opacity-8" />
        <Container fluid>
          <Row className="mt-5">
            {/* <Col className="mb-xl-5">
              <h1 className="text-white">
                  &nbsp;
                <Link to="/admin/execute" style={{float: "right"}} className="btn btn-sm btn-warning"><Add/>&nbsp;New Chat</Link>
              </h1>
            </Col> */}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default DaScreenHeader;
